// extracted by mini-css-extract-plugin
module.exports = {"video":"Video-module--video--16v9S"};